// extracted by mini-css-extract-plugin
export default {"modalWrapper":"Modal_modalWrapper__h3FBl","inner":"Modal_inner__j9XiJ"};